

import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";

export function unitConversionFilter(unitConversionService: UnitConversionService) {

    return (input: string, includeUnit?: boolean, conversionTypeString?: string, precision?: number) => {

        let conversionType = UnitConversionType.Speed;
        if (conversionTypeString) {
            conversionType = unitConversionService.getConversionType(conversionTypeString);
        }

        if (includeUnit) {
            return unitConversionService.convertUnitWithSuffix(input, conversionType, precision);
        }
        else {
            return unitConversionService.convertUnitWithFormatting(input, conversionType, precision);
        }
    }
}
